import Image from "next/image";

import { useTranslation } from "@flare/i18n";

import mainImg from "@/../public/next/images/globe.png";
import { TextField } from "@/components/Funnel/TextField";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

export default function Unsupported() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <div className="m-auto flex max-w-[520px] flex-col items-center justify-center">
            <Image src={mainImg} alt={t("FUNNEL_UNSUPPORTED_IMAGE_ALT")} />
            <StepTitle>{t("FUNNEL_UNSUPPORTED_TITLE")}</StepTitle>
            <StepSubtitle className="text-pretty pt-sp-1">
              {t("FUNNEL_UNSUPPORTED_TEXT")}
            </StepSubtitle>
            <div className="mt-sp-5 w-full">
              <TextField
                name={funnelInputsNameMap.email}
                label={t("FUNNEL_UNSUPPORTED_EMAIL_INPUT_LABEL")}
                placeholder={t("FUNNEL_UNSUPPORTED_EMAIL_INPUT_PLACEHOLDER")}
                validationErrorMessage={t(
                  "FUNNEL_UNSUPPORTED_EMAIL_INPUT_VALIDATION_ERROR",
                )}
                type="email"
                required
              />
            </div>
          </div>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton> {t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
